var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgHeart = function SvgHeart(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.758 26.704L26.915 16.478C29.4104 13.953 29.774 9.82477 27.4166 7.18621C26.8254 6.52129 26.1057 5.9847 25.3015 5.60925C24.4974 5.23379 23.6256 5.02735 22.7396 5.00254C21.8535 4.97773 20.9717 5.13506 20.1481 5.46493C19.3244 5.7948 18.5763 6.29028 17.9492 6.9211L16.0432 8.85267L14.4006 7.18621C11.8927 4.67391 7.79223 4.30779 5.17147 6.68123C4.51103 7.27646 3.97806 8.00102 3.60514 8.81063C3.23221 9.62024 3.02717 10.4979 3.00252 11.39C2.97788 12.2821 3.13415 13.1699 3.4618 13.9991C3.78944 14.8283 4.28158 15.5816 4.90814 16.2129L15.3285 26.704C15.5187 26.8936 15.7755 27 16.0432 27C16.3109 27 16.5678 26.8936 16.758 26.704Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgHeart);
export default ForwardRef;